module.exports = __webpack_public_path__ + "img/c-thermometer-img7-3.ccbed09b.jpg";